export const errorLogger = (
  error: Error,
  customObj?: Record<string, unknown>
) => {
  console.error(error, customObj)
}
